module.exports = __webpack_public_path__ + "img/ic_steps_on.889f19ad.svg";